import React, { useMemo } from 'react';
import './RoundButton.css';

const RoundButton = ({
  children,
  containerClassName = '',
  onClick = () => { },
  primary = false,
  submit = false,
}) => {
  const className = useMemo(() => {
    let cn = 'Round-button';
    if (primary) {
      cn = cn.concat(' Round-button-primary');
    }

    return cn.concat(` ${containerClassName}`);
  }, [containerClassName, primary]);

  return (
    <button
      className={className}
      onClick={onClick}
      type={submit ? 'submit' : 'button'}
    >
      <span>{children}</span>
    </button>
  );
};

export { RoundButton };
